import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Contact } from 'src/app/shared/model/contact';
import { Network } from 'src/app/shared/model/network';
import { NetworkContact } from 'src/app/shared/model/network-contact';
import { NetworkEpgFilesUpload } from 'src/app/shared/model/network-epg-model/network-epg-files-upload';
import { NewNetworkEpg } from 'src/app/shared/model/new-network-epg';
import { EpgDataService } from 'src/app/shared/service/epg-data.service';
import { NetworkContactService } from 'src/app/shared/service/network-contact.service';
import { NetworkEpgService } from 'src/app/shared/service/network-epg.service';
import { environment } from 'src/environments/environment';
import { DeleteNetworkDialogComponent } from './delete-network-dialog/delete-network-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { NetworkGenreService } from 'src/app/shared/service/network-genre.service';
import { GenreService } from 'src/app/shared/service/genre.service';
import { Genre } from 'src/app/shared/model/genre';

@Component({
  selector: 'app-edit-network',
  templateUrl: './edit-network.component.html',
  styleUrls: ['./edit-network.component.scss']
})
export class EditNetworkComponent implements OnInit {
  @Input() selectedNetworkCode: string | null = null;

  pressKitMessage: string;
  factSheetMessage: string;

  defaultLogoUrl: string;
  feedImageMessage: string;

  imageMessage: string;
  updateInProgress: string;
  networkReflectedImage: string;
  imageReflectedMessage: string;


  private unsubscription$: Subject<void> = new Subject<void>();
  networks: NewNetworkEpg[] = [];
  selectedNetwork: NewNetworkEpg | null = null;
  loadingSelectedNetwork = false;
  genres: Genre[] = [];

  networkUrl: string;
  logoUrl: string;
  reflectedLogoUrl: string;
  networkForm: FormGroup;
  isEditing: boolean;

  networkImage: string = "";
  networkEpgLogoUpload: NetworkEpgFilesUpload;
  networkEpgReflectedLogoUpload: NetworkEpgFilesUpload;

  imageExtensions: string[] = [];
  maxWidthLogo: number = 240;
  maxHeightLogo: number = 120;
  maxWidthLogoRef: number = 97;
  maxHeightLogoRef: number = 96;
  networkUpdated: {
    id: number; active: boolean; code: string; factSheet: string; informationEn: string; informationEs: string; informationPt: string; logo: string; nameEn: string; nameEs: string; namePt: string; urlFacebookEn: string; urlFacebookEs: string; urlFacebookPt: string; urlTwitterEn: string; urlTwitterEs: string; urlTwitterPt: string; urlsEn: string; urlsEs: string; urlsPt: string; feedImage: string; feedText: string; feedHorarios: string; pressKit: string; //son varias fotos,
    visible: boolean; activepcm: boolean; genres: Genre[];
  };
  publicationFilesInProcessMessage: string;
  savingInProgress: boolean;
  allowedExtension: string = ".png";
  errorMessage: string;

  listNetworks: NewNetworkEpg[] = [];
  successfulFilesPublicationMessage: string;
  errorDBMessage: string;

  currentNetworkContact: NetworkContact;
  networkContactForm: FormGroup;
  isAddingContact = false;
  contactTypes = ['PRESS', 'AFFILIATE', 'SALES', 'MARKETING', 'COORDINATE'];





  constructor(
    private networkEpgService: NetworkEpgService,
    private epgDataService: EpgDataService,
    private networkGenreService: NetworkGenreService,
    private genreService: GenreService,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private translateService: TranslateService,
    public dialog: MatDialog
  ) {

    this.defaultLogoUrl = environment.bucketUrlImages + "WBD_logo_news.png";
    this.logoUrl = environment.bucketUrlImagesNetworksLogo;
    this.reflectedLogoUrl = environment.bucketUrlImagesNetworks;


    this.unsubscription$ = new Subject<void>();
    this.networkEpgLogoUpload = new NetworkEpgFilesUpload();
    this.networkEpgReflectedLogoUpload = new NetworkEpgFilesUpload();
  }

  ngOnInit(): void {

    this.translateService.stream([
      'epg.networks_upload.messages.errorUpload',
      'epg.networks_upload.messages.errorUpload',
      'epg.networks_upload.messages.successUpload'
    ])
      .pipe(takeUntil(this.unsubscription$))
      .subscribe(translations => this.mapperToMessages(translations));

    this.loadNetworks();
    this.loadGenres();

    this.epgDataService.codeNetworkSubject$.pipe(
      takeUntil(this.unsubscription$)
    ).subscribe((result) => {

      let networkCode = result.codeNetwork
      this.updateSelectedNetwork(networkCode);
    });

    this.networkForm = this.fb.group({
      name_en: ['', Validators.required],
      name_es: ['', Validators.required],
      name_pt: ['', Validators.required],
      code: ['', Validators.required],
      information_en: ['', Validators.required],
      information_es: ['', Validators.required],
      information_pt: ['', Validators.required],
      url_en: ['', [Validators.required, Validators.pattern('https?://.+')]],
      url_es: ['', [Validators.required, Validators.pattern('https?://.+')]],
      url_pt: ['', [Validators.required, Validators.pattern('https?://.+')]],
      url_twitter_en: [''],
      url_twitter_es: [''],
      url_twitter_pt: [''],
      url_facebook_en: [''],
      url_facebook_es: [''],
      url_facebook_pt: [''],
      feeds: [''],
      horarios: [''],
      visible: [false],
      active: [false],
      genres: [[], Validators.required],
      logo: ['']
    });

    this.networkContactForm = this.fb.group({
      typeContacts: this.fb.array([])
    });
  }

  loadNetworks(): void {
    this.isEditing = false;
    this.loadingSelectedNetwork = true;


    this.networkEpgService.getAllNetwork().pipe(
      takeUntil(this.unsubscription$)
    ).subscribe({
      next: (networks: NewNetworkEpg[]) => {
        this.networks = networks;
        this.checkAndLoadSelectedNetwork();
      },
      error: (err) => {
        console.error('Error al cargar las networks', err);
      },
      complete: () => {
        this.loadingSelectedNetwork = false;
      }
    });
  }

  private loadGenres(): void {
    this.genreService.getGenres().subscribe({
      next: (data) => {
        this.genres = data.map((genre) => ({
          ...genre,
          active: false
        }));
      },
      error: (error) => {
        console.error("Error al cargar los géneros:", error);
      }
    });
  }

  checkAndLoadSelectedNetwork(): void {
    if (this.selectedNetworkCode) {
      this.updateSelectedNetwork(this.selectedNetworkCode);
      this.selectedNetworkCode = null;
    }
  }

  loadSelectedNetworkData(): void {
    if (this.selectedNetwork) {
      this.networkForm.patchValue({
        name_en: this.selectedNetwork.nameEn || '',
        name_es: this.selectedNetwork.nameEs || '',
        name_pt: this.selectedNetwork.namePt || '',
        code: this.selectedNetwork.code || '',
        information_en: this.selectedNetwork.informationEn || '',
        information_es: this.selectedNetwork.informationEs || '',
        information_pt: this.selectedNetwork.informationPt || '',
        url_en: this.selectedNetwork.urlsEn || '',
        url_es: this.selectedNetwork.urlsEs || '',
        url_pt: this.selectedNetwork.urlsPt || '',
        url_twitter_en: this.selectedNetwork.urlTwitterEn || '',
        url_twitter_es: this.selectedNetwork.urlTwitterEs || '',
        url_twitter_pt: this.selectedNetwork.urlTwitterPt || '',
        url_facebook_en: this.selectedNetwork.urlFacebookEn || '',
        url_facebook_es: this.selectedNetwork.urlFacebookEs || '',
        url_facebook_pt: this.selectedNetwork.urlFacebookPt || '',
        feeds: this.selectedNetwork.feedText || '',
        horarios: this.selectedNetwork.feedHorarios || '',
        visible: this.selectedNetwork.visible || false,
        active: this.selectedNetwork.active || false,
        logo: this.selectedNetwork.logo || ''
      });

      this.loadSelectedGenres(this.selectedNetwork.id);
      console.log('Estado de los controles:');
      Object.keys(this.networkForm.controls).forEach(controlName => {
        const control = this.networkForm.get(controlName);
        console.log(`${controlName}:`, {
          valid: control.valid,
          errors: control.errors,
          value: control.value
        });
      });
      this.isEditing = false;

      this.networkImage = (this.logoUrl + this.selectedNetwork.code + this.allowedExtension).toLowerCase();
      console.log("url de logo a color:", this.networkImage);
      this.networkReflectedImage = this.reflectedLogoUrl + this.selectedNetwork.logo;

      this.networkForm.disable();
    }
  }

  private loadSelectedGenres(networkId: number): void {
    this.networkGenreService.getGenresByNetwork(networkId).subscribe({
      next: (response) => {
        const selectedGenres = response.genres.map(genre => genre.id);

        this.networkForm.patchValue({
          genres: selectedGenres
        });
      },
      error: (error) => {
        console.error("Error al cargar los géneros:", error);
      }
    });
  }

  updateSelectedNetwork(networkCode: string): void {
    this.selectedNetwork = this.networks.find(network => network.code === networkCode) || null;
    this.loadSelectedNetworkData();
  }

  enableEditing(): void {
    this.isEditing = true;
    this.networkForm.enable();
  }

  onGenreSelect(selectedGenres: number[]) {
    console.log('Géneros seleccionados: ', selectedGenres);

    this.genres.forEach((genre) => {
      genre.active = selectedGenres.includes(genre.id);
    });

    this.networkForm.patchValue({
      genreId: selectedGenres
    });
  }

  save(): void {
    if (this.networkForm && this.networkForm.valid) {
      const selectedGenres = this.networkForm.get('genres')?.value || [];
      if (selectedGenres.length === 0) {
        this.showErrorSnackbar("Debes seleccionar al menos un género.", "Ok");
        return;
      }

      this.savingInProgress = true;

      this.uploadToS3(this.selectedNetwork.id);
    }
    this.isEditing = false;
    this.networkForm.disable();
  }

  uploadToS3(id) {
    let epgUpload = {
      logo: this.networkEpgLogoUpload,
      reflectedLogo: this.networkEpgReflectedLogoUpload
    };

    this.networkEpgService.uploadFilesToS3(epgUpload).subscribe({
      next: (res) => {
        if (res.uploadErrors && res.uploadErrors.length > 0) {
          this.showErrorSnackbar("Error al subir los archivos a S3.", "Ok");
          this.savingInProgress = false;
          return;
        }

        this.registerInDB(id);
      },
      error: (e) => {
        this.showErrorSnackbar("Error al subir los archivos a S3.", "Ok");
        this.savingInProgress = false;
      }
    });
  }

  registerInDB(id) {
    const formValues = this.networkForm.value;

    var logoFileName
    if (this.networkEpgReflectedLogoUpload.fileName != null) {
      logoFileName = this.networkEpgReflectedLogoUpload.fileName;
    } else {
      logoFileName = formValues.logo;
    }


    const selectedNetwork = this.listNetworks.find(network => network.code === formValues.network.code);
    this.networkUpdated = {
      id: id,
      active: formValues.active,
      code: formValues.code,
      factSheet: null,
      informationEn: formValues.information_en,
      informationEs: formValues.information_es,
      informationPt: formValues.information_pt,
      logo: logoFileName,
      nameEn: formValues.name_en,
      nameEs: formValues.name_es,
      namePt: formValues.name_pt,
      urlFacebookEn: formValues.url_facebook_en,
      urlFacebookEs: formValues.url_facebook_es,
      urlFacebookPt: formValues.urlFacebookEs,
      urlTwitterEn: formValues.url_twitter_en,
      urlTwitterEs: formValues.url_twitter_es,
      urlTwitterPt: formValues.url_twitter_pt,
      urlsEn: formValues.url_en,
      urlsEs: formValues.url_es,
      urlsPt: formValues.url_pt,
      feedImage: null,
      feedText: formValues.feeds,
      feedHorarios: formValues.feedHorarios,
      pressKit: null, //son varias fotos,
      visible: formValues.visible,
      activepcm: false,
      genres: formValues.genres,
    };
    console.log("nombre logo:" + this.networkEpgLogoUpload.fileName)


    console.log("nombre logo reflected:", this.networkEpgReflectedLogoUpload.fileName)

    this.networkEpgService.saveNetworkEpg(this.networkUpdated).subscribe({ // IMPORTANTE rxjs switch map o algo similar.
      next: (res) => {
        this.showSnackbar(this.successfulFilesPublicationMessage, "Ok");
        this.savingInProgress = false;
        this.updateNetworkGenresRelation(id, formValues.genres);
        this.isEditing = false;
        this.networkForm.disable();
        this.networkForm.patchValue(res);

      },
      error: (e) => {
        this.showErrorSnackbar(this.errorDBMessage, "Ok");
        this.savingInProgress = false;
      }
    });
  }

  private updateNetworkGenresRelation(networkId: number, genreIds: number[]): void {
    this.networkGenreService.updateNetworkGenresRelation(networkId, genreIds).subscribe({
      next: (res) => {
        console.log("Géneros actualizados correctamente.");
      },
      error: (error) => {
        console.error("Error al actualizar los géneros:", error);
        this.showErrorSnackbar("Error al actualizar los géneros.", "Ok");
      }
    });
  }

  onImageSelected(event: any) {
    const selectedFile = event.target.files[0];

    if (!selectedFile) return;
    const fileName = selectedFile.name;
    const fileExtension = fileName.split('.').pop().toLowerCase();
    const reader = new FileReader();

    this.networkEpgLogoUpload.fileName = (this.selectedNetwork.code + '.' + fileExtension).toLowerCase();

    this.networkEpgLogoUpload.networkFile = selectedFile;

    if (!this.imageExtensions.includes(fileExtension)) {
      this.imageMessage = `El archivo ${fileName} no tiene una extensión válida.`;
    }
    else if (selectedFile.size === 0) {
      this.imageMessage = `El archivo ${fileName} se encuentra vacío.`;
    }


    reader.readAsDataURL(selectedFile);
    reader.onload = (e: any) => {

      const img = new Image();
      img.src = reader.result as string;
      img.onload = () => {

        this.imageMessage = fileName;
        this.networkImage = e.target.result;

      };
    };
  }

  isGenreSelected(genreId: number): boolean {
    const selectedGenres = this.networkForm.get('genres')?.value || [];
    return selectedGenres.includes(genreId);
  }

  onImageReflectedSelected(event: any) {

    const selectedFile = event.target.files[0];

    if (!selectedFile) return;
    const fileName = selectedFile.name;
    const fileExtension = fileName.split('.').pop().toLowerCase();

    const reader = new FileReader();


    //le da al logo el nombre del codigo de la network
    if (selectedFile != null) {
      this.networkEpgReflectedLogoUpload.fileName = (fileName).toLowerCase();
    } else {
      this.networkEpgReflectedLogoUpload.fileName = this.networkForm.value.logo + fileExtension
    }

    this.networkEpgReflectedLogoUpload.networkFile = selectedFile;

    if (!this.imageExtensions.includes(fileExtension)) {
      this.imageReflectedMessage = `El archivo ${fileName} no tiene una extensión válida.`;
    }
    else if (selectedFile.size === 0) {
      this.imageReflectedMessage = `El archivo ${fileName} se encuentra vacío.`;
    }

    reader.readAsDataURL(selectedFile);
    reader.onload = (e: any) => {

      const img = new Image();
      img.src = reader.result as string;
      img.onload = () => {
        this.imageReflectedMessage = fileName;
        this.networkReflectedImage = e.target.result;

      };
    };

  }


  toggleEdit(): void {
    this.isEditing = !this.isEditing;

    if (this.isEditing) {
      this.networkForm.enable();
      this.networkForm.markAsDirty();

      const selectedGenres = this.networkForm.get('genres')?.value || [];
      if (selectedGenres.length === 0) {
        this.showErrorSnackbar("Debes seleccionar al menos un género.", "Ok");
      }
    } else {
      this.cancelEditing();
    }
  }

  cancelEditing(): void {
    if (this.networkUpdated) {
      this.loadSelectedNetworkData();

      this.networkForm.patchValue({
        name_en: this.networkUpdated.nameEn,
        name_es: this.networkUpdated.nameEs,
        name_pt: this.networkUpdated.namePt,
        code: this.networkUpdated.code,
        information_en: this.networkUpdated.informationEn,
        information_es: this.networkUpdated.informationEs,
        information_pt: this.networkUpdated.informationPt,
        url_en: this.networkUpdated.urlsEn,
        url_es: this.networkUpdated.urlsEs,
        url_pt: this.networkUpdated.urlsPt,
        url_twitter_en: this.networkUpdated.urlTwitterEn,
        url_twitter_es: this.networkUpdated.urlTwitterEs,
        url_twitter_pt: this.networkUpdated.urlTwitterPt,
        url_facebook_en: this.networkUpdated.urlFacebookEn,
        url_facebook_es: this.networkUpdated.urlFacebookEs,
        url_facebook_pt: this.networkUpdated.urlFacebookPt,
        feeds: this.networkUpdated.feedText,
        horarios: this.networkUpdated.feedHorarios,
        visible: this.networkUpdated.visible,
        active: this.networkUpdated.active,
        logo: this.networkUpdated.logo
      });
    } else {
      this.loadSelectedNetworkData();
    }

    this.isEditing = false;
    this.networkForm.disable();
  }


  useDefaultImage(reflected: number): void {
    if (reflected) {
      this.networkReflectedImage = this.defaultLogoUrl;
    }
    this.networkImage = this.defaultLogoUrl;

  }

  deleteNetwork() {
    const dialogRef = this.dialog.open(DeleteNetworkDialogComponent, {
      width: '400px',
      data: { networkName: this.selectedNetwork.nameEn },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.confirmed) {
        console.log('la networks será eliminada el:', result.date);
        //  llamar al servicio para eliminar la network pasando la fecha de baja
      } else {
        console.log('Eliminación cancelada');
      }
    });


  }


  // Snackbars
  showSnackbar(message: string, action: string) {
    let config = new MatSnackBarConfig();
    config.duration = 3000;
    config.verticalPosition = "top";
    config.panelClass = ['SuccessfulSnackbar'];
    this.snackBar.open(message, action, config);
  }

  showErrorSnackbar(message: string, action: string) {
    let config = new MatSnackBarConfig();
    config.verticalPosition = "top";
    config.panelClass = ['error-snackbar'];
    this.snackBar.open(message, action, config);
  }

  ngOnDestroy(): void {
    this.unsubscription$.next();
    this.unsubscription$.complete();
  }

  getButtonLabel(): string {
    return this.isEditing ? 'epg.configurationNetworks.cancel' : 'epg.configurationNetworks.edit';
  }

  private mapperToMessages(translations: any): void {
    this.errorMessage = translations['epg.networks_upload.messages.errorUpload'];
    this.errorDBMessage = translations['epg.networks_upload.messages.errorUpload'];
    this.successfulFilesPublicationMessage = translations['epg.networks_upload.messages.successUpload'];
  }
}
